<template>
  <div>
    <CCallout color="info" v-if="typeIndicator === 'CA'">
      <span class="text-muted">Clientes Ventas</span>
      <br>
      <Icon icon="fluent-mdl2:people-repeat" class="text-info mt-1 mr-3" width="28" />
      <strong class="h4 align-middle">{{ clientesAtendidos }}</strong>
    </CCallout>
    <CCallout color="success" v-if="typeIndicator === 'CN'">
      <span class="text-muted">Clientes Nuevos</span>
      <br>
      <Icon icon="fluent-mdl2:people-add" class="text-success mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ clientesNuevos }}</strong>
    </CCallout>
    <CCallout color="danger" v-if="typeIndicator === 'CP'">
      <span class="text-muted">Clientes Perdidos</span>
      <br>
      <Icon icon="fluent-mdl2:people-block" class="text-danger mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ clientesPerdidos }}</strong>
    </CCallout>
    <CCallout color="warning" v-if="typeIndicator === 'PN'">
      <span class="text-muted">Prospectos</span>
      <br>
      <Icon icon="fluent-mdl2:people-alert" class="text-warning mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ prospectosNuevos }}</strong>
    </CCallout>

    <CCallout color="dark" v-if="typeIndicator === 'TO'">
      <span class="text-muted">Clientes</span>
      <br>
      <Icon icon="fluent:people-team-toolbox-20-regular" class="text-dark mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ clientesTotales }}</strong>
    </CCallout>

    <CCallout color="s3green" v-if="typeIndicator === 'AC'">
      <span class="text-muted">Clientes Activos</span>
      <br>
      <Icon icon="fluent:people-team-toolbox-20-regular" class="text-s3green mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ clientesActivos }}</strong>
    </CCallout>

    <CCallout color="s3orange" v-if="typeIndicator === 'MO'">
      <span class="text-muted">Clientes Morosos</span>
      <br>
      <Icon icon="fluent:people-team-toolbox-20-regular" class="text-s3orange mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ clientesMorosos }}</strong>
    </CCallout>

    <CCallout color="s3red" v-if="typeIndicator === 'SU'">
      <span class="text-muted">Clientes Suspendidos</span>
      <br>
      <Icon icon="fluent:people-team-toolbox-20-regular" class="text-s3red mt-1 mr-3" width="28"/>
      <strong class="h4 align-middle">{{ clientesSuspendidos }}</strong>
    </CCallout>

    <LoadingCover v-show="loading" spinner="dotsbar" />
  </div>
</template>

<script>
  import { Icon } from "@iconify/vue2";
  import {
    dataKPIDirectoryQuatity,
  } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  export default {
    name: "CustomerQuantityIndicatorPanel",
    data() {
      return {
        loading: false,
        clientesTotales: 0,
        clientesActivos: 0,
        clientesMorosos: 0,
        clientesSuspendidos: 0,
        clientesInactivos: 0,
        clientesAtendidos: 0,
        clientesNuevos: 0,
        clientesPerdidos: 0,
        prospectosNuevos: 0
      }
    },
    props: {
      typeIndicator: String,
      initialDate: String,
      finalDate: String,
      idStaffGroup: String,
      idEmployee: String
    },
    components: {
      Icon,
      LoadingCover
    },
    methods: {
      async getDataKPIClientsAttended() {
        const parameters = {
          "Tipo_Consulta": this.typeIndicator,
          "Fecha_Inicial": this.initialDate,
          "Fecha_Final": this.finalDate,
          "Id_GrupoEmpleado": this.idStaffGroup,
          "Id_Vendedor": this.idEmployee
        }

        try {
          const { response } = await dataKPIDirectoryQuatity(this, parameters);

          switch (this.typeIndicator) {
            case "TO":
              this.clientesTotales = response.Cantidad;
              break;
            case "AC":
              this.clientesActivos = response.Cantidad;
              break;
            case "MO":
              this.clientesMorosos = response.Cantidad;
              break;
            case "SU":
              this.clientesSuspendidos = response.Cantidad;
              break;
            case "IN":
              this.clientesInactivos = response.Cantidad;
              break;
            case "CA":
              this.clientesAtendidos = response.Cantidad;
              break;
            case "CN":
              this.clientesNuevos = response.Cantidad;
              break;
            case "CP":
              this.clientesPerdidos = response.Cantidad;
              break;
            case "PN":
              this.prospectosNuevos = response.Cantidad;
              break;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async mounted() {
      this.loading = true;

      await this.getDataKPIClientsAttended();

      this.loading = false;
    }
  }
</script>
